import { ReactNode } from 'react';
import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { radius, space } from '@elementary/common-ui/style/utils';

const Wrapper = styled(Flex)<{ $padding?: string }>`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.border.divider};
  border-radius: ${radius('xl')};
  padding: ${({ $padding }) => $padding ?? space('xxl')};
`;

type Props = {
  children?: ReactNode;
  padding?: string;
};

const Card = ({ children, padding }: Props) => (
  <Wrapper $padding={padding}>{children}</Wrapper>
);

export default Card;
